var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlKidsClubOutlined = function SvgHtlKidsClubOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "htlKidsClubOutlined_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 0H0v15.995h16V0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#htlKidsClubOutlined_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 14.997a1 1 0 0 1-1-1v-8a.979.979 0 0 1 .293-.7L7.285 1.28a1 1 0 0 1 1.424-.005l3.993 4.017a.978.978 0 0 1 .292.7H13v8a1 1 0 0 1-1 1l-8 .005Zm0-1h8v-7H4v7Zm7.99-8L8 1.981 4.009 5.997h7.981Zm-2.822 6.52L8.776 11.5h-1.5l-.393 1.017a.5.5 0 0 1-.932-.36L7.56 7.981a.5.5 0 0 1 .932.001l1.609 4.172a.5.5 0 0 1-.933.363ZM8.39 10.5l-.365-.948-.367.948h.732Z"
  }))));
};
export default SvgHtlKidsClubOutlined;